import { Col, Container, Row } from 'reactstrap'
import styles from './Applicabilty.module.scss'
import DataTable from 'react-data-table-component'
import { useState } from 'react'

const Applicability = () => {

  const [showApplicability, setShowApplicability] = useState(false)

  const data = [
    { productId: '001', productName: 'Blue headphones' },
    { productId: '001', productName: 'Blue headphones' },
    { productId: '001', productName: 'Blue headphones' },
  ]

  const columns = [
    { name: 'Product ID', selector: row => row.productId },
    { name: 'Product name', selector: row => row.productName },
    { name: 'Action', selector: () => <span onClick={() => setShowApplicability(!showApplicability)} className={styles['text-orange']}>View</span>, button: true },
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <section>
      <div className={styles['heading']}>Applicability</div>
      <Container className="px-5 d-flex flex-column gap-2 py-2">


        {showApplicability ? (
          <div>

            General Use
          </div>
        ) : (
          <>
            <div>
              <p>Total Applicable Products: <span className={styles['text-orange']}>4</span></p>
            </div>
            <Row>
              <Col>
                <DataTable data={data} columns={columns} customStyles={customStyles} />
              </Col>
              <Col>
                <DataTable data={data} columns={columns} customStyles={customStyles} />
              </Col>
            </Row>
          </>
        )}

      </Container>
    </section>
  )
}

export default Applicability